import React from 'react';
import I18n from 'i18n-js';
import { gql } from '@reverbdotcom/commons/src/gql';
import {
  GearCollectionCSPCardDataFragment,
  CSPPriceRecommendationDataFragment,
  core_apimessages_Money as Money,
} from '@reverbdotcom/commons/src/gql/graphql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCProductCard } from '@reverbdotcom/cadence/components';
import { ToTarget } from '@reverbdotcom/commons/src/link_parser';
import { PriceGuideRecommendationNudge, ProductFinishesNudge } from '../../CardNudges';

interface IProps {
  active: boolean;
  csp: GearCollectionCSPCardDataFragment & CSPPriceRecommendationDataFragment;
  loading: boolean;
  handleClick?: (csp: GearCollectionCSPCardDataFragment) => void;
  href?: ToTarget;
  lowPriceRecommendation?: Money;
  highPriceRecommendation?: Money;
}

export const CSP_CARD_FRAGMENT = gql(`
  fragment GearCollectionCSPCardData on CSP {
    _id
    id
    title
    finishes
    canonicalProductIds
    image(input: { transform: "card_square" }) {
      source
    }
    brand {
      name
    }
  }
`);

function CSPSelectorCard({
  active,
  csp,
  loading,
  handleClick = null,
  href = null,
  lowPriceRecommendation = null,
  highPriceRecommendation = null,
}: IProps) {
  if (loading) { return <RCProductCard.Skeleton />; }

  const { finishes } = csp;
  const finishesCount = finishes?.length || 0;

  return (
    <RCProductCard
      eyebrow={csp.brand?.name}
      title={csp.title.replace(csp.brand?.name, '')}
      imageUrl={csp.image?.source}
      wrapper={href ? {
        type: 'link',
        element: (children) => <CoreLink to={href}>{children}</CoreLink>,
      } : {
        type: 'button',
        element: (children) => (
          <button type="button" onClick={() => handleClick(csp)}>
            {children}
          </button>
        ),
      }}
    >
      {active &&
        <div className="text-utility-350">
          {I18n.t('discovery.sellFlow.tiles.recommended')}
        </div>
      }

      <PriceGuideRecommendationNudge
        lowPriceRecommendation={lowPriceRecommendation}
        highPriceRecommendation={highPriceRecommendation}
      />

      {finishesCount > 1 && <ProductFinishesNudge finishes={finishes} />}

      <div className="sell-card__button">
        {I18n.t('discovery.gearCollections.cspSearch.cardButtonText')}
      </div>
    </RCProductCard>
  );
}

export default CSPSelectorCard;
